import ywk from '@common/utils/ywk'
/**
 * 获取所有的项目列表数据
 */
export const setCategories = ({commit}) => {
  ywk.getJson('/api/appraise/function_tree/all', {}).then((res) => {
    if (res.error_code === 0) {
      let cates = []
      res.data.forEach((item) => {
        item.isSelected = false
        cates.push(item)
      })
      let manager = cates[0]
      commit('SETCATES', cates.slice(1).concat(manager))
    } else {
      ywk.alertFn('error', res.msg)
    }
  })
}

/**
 * 设置选择第一步或者第三步返回回来的项目类别
 * @param {*} param0
 * @param {*} cates
 */
export const setSelectCates = ({commit, state}, id) => {
  state.step.categories.every((item, idx) => {
    if (item.id === id) {
      item.isSelected = !item.isSelected
      item.pageNum = 1
      return false
    }
    return true
  })
  state.step.selectData.every((item, idx) => {
    if (item.id === id) {
      item.isSelected = !item.isSelected
      item.pageNum = 1
      return false
    }
    return true
  })
}

/**
 * 保存计算后的价格
 * @param {*Object} param0
 * @param {*Object} data
 */
export const saveEvaluation = ({commit}, data) => {
  commit('SAVEEVALUATION', data)
}

/**
 * 设置勾选的数据
 * @param {*Object} param0
 * @param {*Object} data
 */
export const setSelectData = ({commit}, data) => {
  commit('SETSELECTDATA', data)
}
